/** Pure new-active-outage detection for the operator toast/notification
 *  (spec §4.4). Given the ids seen on the previous poll and the current active
 *  list, return the ids that are NEW this poll (present now, absent before). The
 *  hook seeds `prev` from the first poll so the initial load never toasts. */
import type { OutageListItem } from '../../types/oms.ts'

export function newOutageIds(
  prevIds: ReadonlySet<number>,
  current: readonly OutageListItem[],
): number[] {
  return current
    .filter(o => o.status === 'active' && !prevIds.has(o.id))
    .map(o => o.id)
}

/** The id set for the current active list (what the next poll compares against). */
export function activeIdSet(current: readonly OutageListItem[]): Set<number> {
  return new Set(current.filter(o => o.status === 'active').map(o => o.id))
}
